/**
 * Single source of truth for supported locales.
 * Used by next-intl config and by scripts/i18n/sync.ts.
 */

export const locales = [
  'en',
  'es',
  'fr',
  'zh',
  'ja',
  'ko',
  'pt',
  'de',
  'hi',
  'ru',
  'tr',
  'it',
  'id',
  'vi',
  'nl',
  'pl',
  'th',
  'uk',
  'ro',
  'tl',
  'sv',
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

/** Stable default for next-intl date/time formatting (avoids ENVIRONMENT_FALLBACK / hydration skew). */
export const defaultTimeZone = 'UTC';

/** Locales we translate to from en (all except en). */
export const targetLocales: readonly Exclude<Locale, 'en'>[] = locales.filter(
  (l: Locale): l is Exclude<Locale, 'en'> => l !== 'en',
);
